export default __webpack_public_path__ + "static/media/white_sugar_1.a1440220.png";